export default function PageHeader({ kicker, title, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        {kicker && <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-700">{kicker}</p>}
        <h1 className="font-display font-black text-2xl sm:text-3xl lg:text-4xl tracking-tight mt-1">{title}</h1>
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}

export function Empty({ title, children, testId }) {
  return (
    <div className="hf-card p-10 text-center hf-grid-bg" data-testid={testId}>
      <p className="font-display font-bold text-lg">{title}</p>
      <div className="text-sm text-slate-600 mt-2">{children}</div>
    </div>
  );
}
